/* tslint:disable */
import {Injectable} from '@angular/core';
import {Headers, Http, Jsonp, RequestOptions} from "@angular/http";
import 'rxjs/add/operator/toPromise';
import * as wjcCore from 'wijmo/wijmo';
import * as wjcNav from 'wijmo/wijmo.nav';
import {items} from "./home-page/right-container/container/doc-manage/items";
import {async} from "rxjs/scheduler/async";
import {PromiseObservable} from "rxjs/observable/PromiseObservable";
import {Observable} from "rxjs";
import {promise} from "selenium-webdriver";


@Injectable()
export class CpcWebApiService {
  private iniUrl: string = "../jsp/loginman.jsp?loginguid=loginguidng2&format=mjson";
  private url: string = "../jsp/loginman.jsp?loginguid=loginguidng2&format=mjson";
  private sessionId: string;
  private loginGUId: string;
  private options: RequestOptions;
  base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  base64DecodeChars = new Array(-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1);

  //打开文件 需要传的参数 登录的时候 从 getEntCode.jsp 获取
  WebtoolCRC32 = '';
  Webtool2CRC32 = '';
  //单点登出的需要跳转的路径
  sso_logout_url = '';
  //cssql 防止sql注入
  getPostUrl(classid: string, action: string,cssql:any): string {
    if(cssql){
      return this.url + "&classid=" + classid.toLowerCase() + "&action=" + action.toLowerCase()+ "&cs="+cssql;
    }
    return this.url + "&classid=" + classid.toLowerCase() + "&action=" + action.toLowerCase();
  }

  setLoginGUId(loginguid: string) {
    this.loginGUId = loginguid;
    this.url = this.url.replace('loginguidng2', loginguid);
  }

  getLoginGUId(): string {
    return this.loginGUId;
  }

  setSessionId(sessionId) {
    this.sessionId = sessionId;
  }

  //防伪标志
  getBytesCount(str:string) {
    // 非字符串 不作计算
    if (typeof str !== 'string') return;
    let blob = new Blob([str], { type: 'application/json;charset=utf8' });
    return blob.size;
  }
  post(classid, action, data) {
    // sql的请求 sqlwhere(未加密) 自动加密
    if(data["sqlwhere"] && data["sqlwhere"][0]!= "*"){
      data["sqlwhere"] = this.getEncodeSQL(data["sqlwhere"]);
    }
    // sql的请求 sql(未加密) 自动加密
    if(data["sql"] && data["sql"][0]!= "*"){
      data["sql"] = this.getEncodeSQL(data["sql"]);
    }
    let stringData = JSON.stringify(data);
    let datalen = this.getBytesCount(stringData);
    let cs = datalen+"";
    for (let i = 0; i < (datalen+"").length; i++)
    {
      let num:any = 10*Math.random();
      cs =  cs+""+parseInt(num);
    }
    cs = encodeURIComponent(this.getEncodeSQL(cs));
    //加多一个请求标志
    this.options.headers.set('cs',cs);

    return this.http.post(
      this.getPostUrl(classid, action,cs),
      JSON.stringify(data),
      this.options
    ).toPromise();
  }


  destroy() {
    this.url = this.iniUrl;
    this.sessionId = null;
    this.loginGUId = null;
    this.g_checkDocArray = [];
  }
  constructor(private http: Http, private jsonp: Jsonp) {
    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    this.options = new RequestOptions({headers: headers});
    //启动监听
    this.getCheckOutDocStat();
  }

  /**
   * 判断url地址是否可用
   * @param url
   * @returns {boolean}
   */
  async testUrl(url): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.jsonp.get(url).subscribe(data => {
        if (data.url) {
          resolve(true);
        } else {
          resolve(false);
        }
      }, error => {
        if (error.url) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  //取个人参数的值 的方法
  async getCpcUserProfileValue(confname) {
    let data = {
      confname: confname,
      conftype: 2
    };
    let value = '';
    await this.post('cpcwebuser','getconfvalue',data).then(res =>{
      let data  = res.json();
      value = data.userconfofusers[0][confname];
    });
    return value;
  }


  //取系统参数的值 的方法
  async getCpcSysconfValue(confname){
      let data = {
        confname: confname
      };
      let value = '';
      await this.post('cpcwebuser','getconfvalue',data).then(res =>{
        let data  = res.json();
        value = data.sysconfofusers[0][confname];
      });
      return value;
   }
  public  g_checkDocArray = [];

  /*检出文件状态更新监听*/
  getCheckOutDocStat() {
    let timeInterval = 2000;
    let that= this;
    let time = setInterval(function () {
      for (let d = 0; d < that.g_checkDocArray.length; d++) {
        let obj = that.g_checkDocArray[d];
        let url = 'http://localhost:9988?action=getdocstat&loginguid=' + that.getLoginGUId() + '&docid=' + obj.docid + '&rev=' + obj.rev;
        that.http.get(url).toPromise().then(response => {
          let stat = '0';
            try { stat = response.json();}
            catch (e){
              console.log(response);
            }
            if (stat == '1') {
              console.log(obj.docid+' 检入了。');
              //移除对改文件的监听 //console.log(g_checkDocArray);
              that.g_checkDocArray.splice(d, 1);
              if (obj.callBackFunc) {
                console.log('回调');
                obj.callBackFunc();
              }

            }



        },
        error=>{
          console.log(error);
        });


      }

    }, timeInterval);
  }

  /**  //文档打开方式的处理方法 门户里面所有的 打开文档的 方法都调用这个方法
   * @param data 打开的文档的数据
   * @param opentype 打开的方式 0 直接下载 手工本地打开 1 调用插件打开
   * @param even
   * @param message  需要的 entcode 和 loginguid
   * @param webToolDownLoadUrl  没有检测到 webtool显示 提醒下载界面
   * @param useFontJudgeOnly  启动一个参数 判断是否用字体 来鉴别webtool是否安装
   */

  openFileFunc(data,opentype,even,message,webToolDownLoadUrl:any,useFontJudgeOnly:any){
    if(opentype == '1'){
      let uri, failCb, ok_callback, prompt_callback,serverurl,docid,rev;
      docid = data.docid ? data.docid:(data.refid?data.refid:data.objid);
      rev = data.rev ? data.rev:data.refrev;
      serverurl = 'http://'+location.hostname+':'+location.port;
      if(even=='export'){
        uri = 'webtool://action/?' + this.base64encode(this.utf16to8(this.base64encode(this.utf16to8(
          'initparam=appid=|loginguid=' + message.loginGuid +
          '|entcode=' + message.entCode +
          '|even='+even+
          '|docid='+data.join(',')+ //
          '|rev=-1'+ //
          '|userid='+message.userId+
          '|entid='+message.entId+
          '|invorgid='+message.currmrporgid+
          '|serverurl='+serverurl+
          '|webtoolcrc32=' + this.WebtoolCRC32 +
          '|webtool2crc32=' + this.Webtool2CRC32
        ))));
      }else{
        uri = 'webtool://action/?'+this.base64encode(this.utf16to8(this.base64encode(this.utf16to8('initparam=appid=|loginguid=' + message.loginGuid + '|entcode=' + message.entCode +'|even='+even+'|docid='+docid+'|rev='+rev+'|userid='+message.userId+'|entid='+message.entId+'|invorgid='+message.currmrporgid+'|serverurl='+serverurl+ '|webtoolcrc32=' + this.WebtoolCRC32 + '|webtool2crc32=' + this.Webtool2CRC32))));
      }
      // console.log(uri);
      this.protocolCheck(uri,useFontJudgeOnly,
        function(){//失败回调
          this.failCb(webToolDownLoadUrl);
        }
        ,function () {//成功回调
          console.log('调用接口成功了');
        },'');
    }
    else{
      let download_url='';
      if(data.docname || data.refname || data.downloadcode){
        download_url = window.location.protocol
          + '//' + window.location.host
          + '/downloadfile.do?iswb=true&filecode=' + data.downloadcode;
        // window.open(window.location.protocol
        //   + '//' + window.location.host
        //   + '/downloadfile.do?iswb=true&filecode=' + data.downloadcode, '-parent');
      }
      else if(data.loadUrl){
        download_url = data.loadUrl;
        // window.open(data.loadUrl, '-parent');
      }
      console.log(download_url);
      if(navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i)){
        // 如果是mac的safari有可能会阻止window.open()执行，需要特殊处理
        let iframe=document.createElement('iframe');
        iframe.src=download_url;
        document.querySelector('body').appendChild(iframe);
        setTimeout(() => {
          document.querySelector('body').removeChild(iframe);
        }, 1500);
      }else{
        window.open(download_url, '-parent');
      }
    }
  }

  /** 协议
   * @param uri  协议
   * @parm useFontJudgeOnly 是否用字体判断 webtool是否安装
   * @param failCb 失败回调
   * @param ok_callback 成功回调
   * @param prompt_callback 不知道干啥的
   */
  protocolCheck(uri,useFontJudgeOnly, failCb, ok_callback, prompt_callback) {
    (function(d){function c(c){b.style.fontFamily=c;e.appendChild(b);f=b.clientWidth;e.removeChild(b);return f}let f,e=d.body,b=d.createElement("span");b.innerHTML=Array(100).join("wi");b.style.cssText=["position:absolute","width:auto","font-size:128px","left:-99999px"].join(" !important;");let g=c("monospace"),h=c("serif"),k=c("sans-serif");(<any>window).isFontAvailable=function(b){return g!==c(b+",monospace")||k!==c(b+",sans-serif")||h!==c(b+",serif")}})(document);
    function failCallback() {
      failCb && failCb();
    }
    if ((<any>window).isFontAvailable('WebToolFont')) {
     try {
          window.location.href = uri;
        }
        catch (e) {
          alert(e);
        }

    }
    else if(useFontJudgeOnly == '2'){
      failCallback();
    }
    else{
      if (localStorage.getItem('stopShow') == 'true') {
        ok_callback();
        return;
      }
      let browser = this.checkBrowser();
      if (browser.isFirefox) {
        this.openUriUsingFirefox(uri, failCallback);

      }
      if (browser.isChrome) {
        this.openUriWithTimeoutHack(uri, failCallback);
        //console.log(window.location.href);
      }
      if (browser.isIE) {
        this.openUriUsingIE(uri, failCallback);
      }
    }
  }
  failCb(webToolDownLoadUrl){
    //新建一个div元素节点
    if(webToolDownLoadUrl&& webToolDownLoadUrl.length>0){
      let  mask=document.createElement("div");
      //把div元素节点添加到body元素节点中成为其子节点，但是放在body的现有子节点的最后
      document.body.appendChild(mask);
      mask.setAttribute('id', 'downLoadWebToolDialogMask');
      //用于定位的div
      let  positionDiv=document.createElement("div");
      let dialog = document.createElement("div");
      dialog.setAttribute('class', 'downLoadWebToolDialog');
      //头
      let header = document.createElement("div");
      header.setAttribute('class', 'downLoadWebToolDialogHeader');
      header.innerHTML='温馨提示';
      //中
      let content = document.createElement("div");
      content.setAttribute('class', 'downLoadWebToolDialogContent');
      content.innerHTML = '检测到您未安装插件，请点击下载安装插件。';
      let a = document.createElement('a');
      a.innerHTML ='下载';
      a.href = 'javascript:;';
      a.addEventListener('click', function(e) {
        e.stopPropagation();//取消事件冒泡
        window.open(webToolDownLoadUrl);
      });
      content.appendChild(a);
      //尾
      let footer = document.createElement("div");
      footer.setAttribute('class', 'downLoadWebToolDialogFooter');
      let button = document.createElement("button");
      button.innerHTML = '关闭';
      button.addEventListener('click', function(e) {
        e.stopPropagation();//取消事件冒泡
        let  idObject = document.getElementById('downLoadWebToolDialogMask');
        if (idObject != null) idObject.parentNode.removeChild(idObject);
      });
      footer.appendChild(button);

      dialog.appendChild(header);
      dialog.appendChild(content);
      dialog.appendChild(footer);
      positionDiv.appendChild(dialog);
      mask.appendChild(positionDiv);
    }
    else{
      alert('检测到没有配置安装插件的路径，请联系管理员！');
    }
  }
  checkBrowser() {
    let isOpera = !!(<any>window).opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    return {
      isOpera: isOpera,
      isFirefox: typeof (<any>window).InstallTrigger !== 'undefined',
      isSafari: Object.prototype.toString.call((<any>window).HTMLElement).indexOf('Constructor') > 0,
      isChrome: !!(<any>window).chrome && !isOpera,
      isIE: (/*@cc_on!@*/false || !!(<any>document).documentMode) && (!this.IsMaxthon())   // At least IE6
    }
  }

  jConfirm(message, title, callback) {
    (<any>window).confirm(message, title, callback);
  }

  createHiddenIframe(target, uri) {
    let iframe = document.createElement("iframe");
    iframe.src = uri;
    iframe.id = "hiddenIframe";
    iframe.style.display = "none";
    target.appendChild(iframe);
    return iframe;
  }

  openUriWithHiddenFrame(uri, failCb) {

    let iframe = document.querySelector("#hiddenIframe");
    if (!iframe) {
      iframe = this.createHiddenIframe(document.body, "about:blank");
    }

    (<any>iframe).onload = function () {
      failCb();
    };
    (<any>iframe).src = uri;

  }

  openUriWithTimeoutHack(uri, failCb) {

    let timeout = setTimeout(function () {
      failCb();
      handler.remove();
    }, 3000);

    let handler = this._registerEvent(window, "blur", onBlur);

    function onBlur() {
      clearTimeout(timeout);
      handler.remove();
    }

    (<any>window).location = uri;
  }

  _registerEvent(target, eventType, cb) {
    if (target.addEventListener) {
      target.addEventListener(eventType, cb);
      return {
        remove: function () {
          target.removeEventListener(eventType, cb);
        }
      };
    } else {
      target.attachEvent(eventType, cb);
      return {
        remove: function () {
          target.detachEvent(eventType, cb);
        }
      };
    }
  }

  openUriUsingFirefox(uri, failCb) {
    let iframe = document.querySelector("#hiddenIframe");
    if (!iframe) {
      iframe = this._createHiddenIframe(document.body, "about:blank");
    }
    try {
      (<any>iframe).contentWindow.location.href = uri;

    } catch (e) {
      if (e.name == "NS_ERROR_UNKNOWN_PROTOCOL") {
        failCb();
      }
    }
  }

  openUriUsingIE(uri, failCb) {
    //check if OS is Win 8 or 8.1
    let ua = navigator.userAgent.toLowerCase();
    let isWin8 = /windows nt 6.2/.test(ua) || /windows nt 6.3/.test(ua);

    if (isWin8 || navigator.msLaunchUri) {
      this.openUriUsingIEInWindows8(uri, failCb);
    }
    else {
      if (this.getInternetExplorerVersion() === 10) {
        this.openUriUsingIE10InWindows7(uri, failCb);
      } else if (this.getInternetExplorerVersion() === 9 || this.getInternetExplorerVersion() === 11 /*|| typeof(useHidden) != 'undefined'*/) {
        this.openUriWithHiddenFrame(uri, failCb);
      } else {
        this.openUriInNewWindowHack(uri, failCb);
      }
      // let fso,s="C:/SinoCCGroup/WebTool/webtool.exe";
      // fso= new (<any>window).ActiveXObject("Scripting.FileSystemObject");
      // try {
      //   if(fso.FileExists(s)){
      //     let iframe = document.querySelector("#hiddenIframe");
      //     if (!iframe) {
      //       iframe = this._createHiddenIframe(document.body, "about:blank");
      //     }
      //
      //     (<any>iframe).contentWindow.location.href = uri;
      //
      //   }
      //   else{
      //     failCb();
      //   }
      // } catch (e) {
      //
      // }
    }
  }

  openUriUsingIE10InWindows7(uri, failCb) {
    let timeout = setTimeout(failCb, 15000);
    window.addEventListener("blur", function () {
      clearTimeout(timeout);
    });

    let iframe = document.querySelector("#hiddenIframe");
    if (!iframe) {
      iframe = this._createHiddenIframe(document.body, "about:blank");
    }
    try {
      (<any>iframe).contentWindow.location.href = uri;
    } catch (e) {
      failCb();
      clearTimeout(timeout);
    }
  }

  getInternetExplorerVersion() {
    let rv = -1;
    if (navigator.appName === "Microsoft Internet Explorer") {
      let ua = navigator.userAgent;
      let re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
      if (re.exec(ua) != null)
        rv = parseFloat(RegExp.$1);
    }
    else if (navigator.appName === "Netscape") {
      let ua = navigator.userAgent;
      let re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
      if (re.exec(ua) != null) {
        rv = parseFloat(RegExp.$1);
      }
    }
    return rv;
  }

  _createHiddenIframe(target, uri) {
    let iframe = document.createElement("iframe");
    iframe.src = uri;
    iframe.id = "hiddenIframe";
    iframe.style.display = "none";
    target.appendChild(iframe);
    return iframe;
  }

  openUriInNewWindowHack(uri, failCb) {
    let myWindow = window.open('', '', 'width=0,height=0');

    try {
      myWindow.document.write("<iframe src='" + uri + "'></iframe>");
      let t = setTimeout(function () {
        try {
          clearTimeout(t);
          myWindow.location.href;
          myWindow.setTimeout("window.close()", 100);

        } catch (e) {
          myWindow.close();
          failCb();
        }
      }, 100);
    } catch (e) {
      myWindow.close();
      failCb();
    }
  }


  openUriUsingIEInWindows8(uri, failCb) {
    if (navigator.msLaunchUri) {
      navigator.msLaunchUri(uri,
        function () {
          window.location.href = uri;
        },
        failCb
      );
    }
  }


  IsMaxthon() {
    try {
      (<any>window).external.max_invoke("GetHotKey");
      return true;
    } catch (e) {
      return false;
    }
  }

  base64encode(str) {
    let out, i, len;
    let c1, c2, c3;
    len = str.length;
    i = 0;
    out = "";
    while (i < len) {
      c1 = str.charCodeAt(i++) & 0xff;
      if (i == len) {
        out += this.base64EncodeChars.charAt(c1 >> 2);
        out += this.base64EncodeChars.charAt((c1 & 0x3) << 4);
        out += "==";
        break;
      }
      c2 = str.charCodeAt(i++);
      if (i == len) {
        out += this.base64EncodeChars.charAt(c1 >> 2);
        out += this.base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
        out += this.base64EncodeChars.charAt((c2 & 0xF) << 2);
        out += "=";
        break;
      }
      c3 = str.charCodeAt(i++);
      out += this.base64EncodeChars.charAt(c1 >> 2);
      out += this.base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
      out += this.base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6));
      out += this.base64EncodeChars.charAt(c3 & 0x3F);
    }
    return out;
  }

  base64decode(str: string) {
    let c1, c2, c3, c4;
    let i, len, out;
    len = str.length;
    i = 0;
    out = "";
    while (i < len) {
      /* c1 */
      do {
        c1 = this.base64DecodeChars[str.charCodeAt(i++) & 0xff];
      } while (i < len && c1 == -1);
      if (c1 == -1)
        break;
      /* c2 */
      do {
        c2 = this.base64DecodeChars[str.charCodeAt(i++) & 0xff];
      } while (i < len && c2 == -1);
      if (c2 == -1)
        break;
      out += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));
      /* c3 */
      do {
        c3 = str.charCodeAt(i++) & 0xff;
        if (c3 == 61)
          return out;
        c3 = this.base64DecodeChars[c3];
      } while (i < len && c3 == -1);
      if (c3 == -1)
        break;
      out += String.fromCharCode(((c2 & 0XF) << 4) | ((c3 & 0x3C) >> 2));
      /* c4 */
      do {
        c4 = str.charCodeAt(i++) & 0xff;
        if (c4 == 61)
          return out;
        c4 = this.base64DecodeChars[c4];
      } while (i < len && c4 == -1);
      if (c4 == -1)
        break;
      out += String.fromCharCode(((c3 & 0x03) << 6) | c4);
    }
    return out;
  }

  /**
   * @param str
   */
  utf16to8(str) {
    let out, i, len, c;
    out = "";
    len = str.length;
    for (i = 0; i < len; i++) {
      c = str.charCodeAt(i);
      if ((c >= 0x0001) && (c <= 0x007F)) {
        out += str.charAt(i);
      } else if (c > 0x07FF) {
        out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
        out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
        out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
      } else {
        out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
        out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
      }
    }
    return out;
  }
  /**
   * @param str
   */

  utf8to16(str) {
    let out, i, len, c;
    let char2, char3;
    out = "";
    len = str.length;
    i = 0;
    while (i < len) {
      c = str.charCodeAt(i++);
      switch (c >> 4) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
          // 0xxxxxxx
          out += str.charAt(i - 1);
          break;
        case 12:
        case 13:
          // 110x xxxx  10xx xxxx
          char2 = str.charCodeAt(i++);
          out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
          break;
        case 14:
          // 1110 xxxx 10xx xxxx 10xx xxxx
          char2 = str.charCodeAt(i++);
          char3 = str.charCodeAt(i++);
          out += String.fromCharCode(((c & 0x0F) << 12) |
            ((char2 & 0x3F) << 6) |
            ((char3 & 0x3F) << 0));
          break;
      }
    }
    return out;
  }

  /**************************各种工作区的 公用方法(包括 )***********************/


  // 左边 不同的文件类型 匹配不同的小图标 有 文件夹 快捷方式的文件夹 业务文档类
  /**
   * @param treeView Dom节点
   * @param e $event
   * @param rootlogo 根节点logo
   * @param workspacelogo 工作区logo
   * @param parentlogo 父节点
   * @param childlogo  子节点logo
   */
  formatImg(treeView: wjcNav.TreeView, e: wjcNav.FormatNodeEventArgs,rootlogo:any,workspacelogo:any,parentlogo:any) {
    if (e.level == 0) { //根节点
      let newnode = document.createElement('i');
      newnode.style.color = '#f0bd29';
      newnode.style.marginRight = '5px';
      newnode.setAttribute('class', rootlogo?rootlogo:'fa fa-folder-open fa-1x');
      let a = e.element.children[0];
      e.element.insertBefore(newnode, a);
    }
    if (e.level == 1) {//文档工作区
      let newnode = document.createElement('i');
      newnode.style.color = '#0085c7';
      newnode.style.marginRight = '5px';
      newnode.setAttribute('class', workspacelogo?workspacelogo:'fa fa-desktop fa-1x');
      let a = e.element.children[0];
      e.element.insertBefore(newnode, a);
    }
    if (e.level > 1) {
      let newnode = document.createElement('i');
      newnode.style.marginRight = '5px';
      if (Number(e.dataItem.id) < 0) {//系统文件 颜色浅一点
        newnode.style.color = 'rgb(77, 191, 248)';
      } else {//自定义文件  颜色深一点
        newnode.style.color = '#0085c7';
      }

      if (e.dataItem.data.dssname) {//业务图标
        newnode.setAttribute('class', 'fa fa-clipboard fa-1x');
      }

      else if (e.dataItem.data.scname) {//快捷方式的文件夹 不是快捷方式的文件
        newnode.setAttribute('class', 'fa fa-share-square fa-1x');
      }
      else {//文件夹图标

        //别人共享的文件夹
        if(e.dataItem.data.issecret==9){
          newnode.setAttribute('class', 'fa fa-laptop fa-1x');
        }
        else{
          newnode.setAttribute('class', parentlogo?parentlogo:'fa fa-folder fa-1x');
        }
      }
      let a = e.element.children[0];
      e.element.insertBefore(newnode, a);
    }
  }


  /**
   * 各类文档的排序  用于 sort排序
   */
  ReOrderDataList(obja, objb) {
    //从typepath获取对象类型
    function getObjType(obj) {
      if (obj.typepath) {
        let tp = obj.typepath.substring(0, obj.typepath.length - 1);
        return Number(tp.substring(tp.lastIndexOf("\\") + 1));
      } else {
        return 0;
      }
    }

    //扩展wbs码
    function ExpandOutline(wbs) {
      if (!wbs) {
        return "";
      }
      let ar = wbs.split(".");
      let result = "";
      for (let i = 0; i < ar.length; i++) {
        if (ar[i]) {
          for (let j = 0; j < (4 - ar[i].length); j++) {
            result += "0";
          }
          result += ar[i] + "."
        }
      }
      result = result.substring(0, result.length - 1);
      return result;
    }
    //不同浏览器的 对于 localeCompare方法的  中英比较返回的值都不太一样 所以要确定把英文放在中文之前
    // 所以英文和中文  比较要英文在前
    function compare(a,b){
      return ('f'.localeCompare('黄','zh') == -1)?a.localeCompare(b,'zh'):b.localeCompare(a,'zh');
    }
    //相同的业务对象根据 name来排序，仿照 windows的 文档排序
    function SortLikeWin(name1, name2) {
      let a = name1;
      let b = name2;
      let reg = /^[0-9]+/;
      let lista = a.match(reg);
      let listb = b.match(reg);
      if (!lista || !listb){
        //直接调用 localeCompare这个方法 中英文比较  会把中文排序到前面，
        // 但是 需求是 英文要先排序。所以要单独处理 中英文的比较
        let  num = /[0-9]/;
        let  en = /[a-z]/i;
        let  zh = new RegExp("[\\u4E00-\\u9FFF]+");

        let  starta=a.substring(0,1);
        let  startb=b.substring(0,1);
        let aWhat = num.test(starta)?'num':en.test(starta)?'en':zh.test(starta)?'zh':'';
        let bWhat = num.test(startb)?'num':en.test(startb)?'en':zh.test(startb)?'zh':'';
        //('f'.Localeompare('黄')==-1)?xx.localeCompare(yy):yy.localeCompare(xx)
        if((aWhat == 'zh'&& bWhat == 'en') || (aWhat == 'en' && bWhat == 'zh')){
          return  compare(a,b);
        }
        return a.localeCompare(b);
      }


      for (let i = 0, minLen = Math.min(lista.length, listb.length); i < minLen; i++) {
        //数字所在位置序号
        let indexa = a.indexOf(lista[i]);
        let indexb = b.indexOf(listb[i]);
        //数字前面的前缀
        let prefixa = a.substring(0, indexa);
        let prefixb = a.substring(0, indexb);
        //数字的string
        let stra = lista[i];
        let strb = listb[i];
        //数字的值
        let numa = parseInt(stra);
        let numb = parseInt(strb);
        //如果数字的序号不等或前缀不等，属于前缀不同的情况，直接比较
        if (indexa != indexb || prefixa != prefixb) {
          return a.localeCompare(b);
        }
        else {
          //数字的string全等
          if (stra === strb) {
            //如果是最后一个数字，比较数字的后缀
            if (i == minLen - 1) {
              return a.substring(indexa).localeCompare(b.substring(indexb));
            }
            //如果不是最后一个数字，则循环跳转到下一个数字，并去掉前面相同的部分
            else {
              a = a.substring(indexa + stra.length);
              b = b.substring(indexa + stra.length);
            }
          }
          //如果数字的string不全等，但值相等
          else if (numa == numb) {
            //直接比较数字前缀0的个数，多的更小
            return strb.lastIndexOf(numb + '') - stra.lastIndexOf(numa + '');
          }
          else {
            //如果数字不等，直接比较数字大小
            return numa - numb;
          }
        }
      }

    }

    let intTmp1 = obja.objtype = getObjType(obja);
    let intTmp2 = objb.objtype = getObjType(objb);

    switch (intTmp1) {
      case 1:
        intTmp1 = 0;
        break;
      case 2:
        intTmp1 = 1;
        break;
      case 5:
        intTmp1 = 100;
        break;
      case 17:
        intTmp1 = 2;
        break;
    }
    switch (intTmp2) {
      case 1:
        intTmp2 = 0;
        break;
      case 2:
        intTmp2 = 1;
        break;
      case 5:
        intTmp2 = 100;
        break;
      case 17:
        intTmp2 = 2;
        break;
    }
    if (obja.objtype == 0) {
      return 0;
    }

    //两种不同业务对象
    if (obja.objtype != objb.objtype) {
      return intTmp1 - intTmp2;
    }
    else {
      //业务对象为Tss类型,按Code属性排序
      let strTmp1;
      let strTmp2;
      let result = 0;
      switch (obja.objtype) {
        case 2: //文件夹
          //如果对象为文件夹，FdrId<0 为系统文件夹，应该排在最前面
          intTmp1 = obja.fdrid || obja.refid;
          intTmp2 = objb.fdrid ||  objb.refid;
          if (Number(intTmp1) < 0) {
            strTmp1 = ' ';
          } else {
            strTmp1 = obja.fdrname || obja.scname;
          }
          if (Number(intTmp2) < 0) {
            strTmp2 = ' ';
          } else {
            strTmp2 = objb.fdrname || objb.scname;
          }
          let name_a;
          let name_b;
          if (!isNaN(parseFloat(strTmp1)) && !isNaN(parseFloat(strTmp2))) {
            name_a = parseFloat(strTmp1);
            name_b = parseFloat(strTmp2);
          }
          if (!isNaN(parseFloat(strTmp2))) {
            name_b = parseFloat(strTmp2);
          }
          result = SortLikeWin(strTmp1,strTmp2);
          // result = strTmp1.localeCompare(strTmp2);
          break;
        case 4: //构件
          strTmp1 = obja.code;
          strTmp2 = objb.code;
          result = strTmp1.localeCompare(strTmp2);
          break;
        case 6: //文档
          strTmp1 = obja.docname;
          strTmp2 = objb.docname;

          result = SortLikeWin(strTmp1,strTmp2);
          // result = strTmp1.localeCompare(strTmp2);
          break;
        case 8: //任务，按照‘(WBS) 名称’排列
          strTmp1 = '(' + ExpandOutline(obja.outline) + ') ' + obja.taskname;
          strTmp2 = '(' + ExpandOutline(objb.outline) + ') ' + objb.taskname;
          result = SortLikeWin(strTmp1,strTmp2);
          // result = strTmp1.localeCompare(strTmp2);
          break;
        case 10: //结构
          intTmp1 = obja.seq;
          //如果序号为 0 ，使用 TssCode 排序
          if (intTmp1 == 0) {
            strTmp1 = obja.tsscode;
            strTmp2 = objb.tsscode;
            result = strTmp1.localeCompare(strTmp2);
          }
          else {
            intTmp2 = objb.seq;
            result = intTmp1 - intTmp2;
          }
          break;
        case 11: //配置
          intTmp1 = obja.seq;
          //如果序号为 0 ，使用 TssCode 排序
          if (intTmp1 == 0) {
            strTmp1 = obja.tsscode;
            strTmp2 = objb.tsscode;
            result = strTmp1.localeCompare(strTmp2);
          }
          else {
            intTmp2 = objb.seq;
            result = intTmp1 - intTmp2;
          }
          break;
        case 17: //关键分类
          strTmp1 = obja.keyccode + '.' + obja.keycname;
          strTmp2 = objb.keyccode + '.' + objb.keycname;
          result = strTmp1.localeCompare(strTmp2);
          break;
        case 24: //BBS
          // 按 创建时间 或者 修改时间来排序
          strTmp1 = obja.updatetime || obja.createtime; // CreateTime  UpdateTime
          strTmp2 = objb.updatetime || objb.createtime; // CreateTime  UpdateTime
          result = strTmp2.localeCompare(strTmp1); // 倒序
          break;
        case 25: //快捷方式
          strTmp1 = obja.scname;
          strTmp2 = objb.scname;
          result = SortLikeWin(strTmp1,strTmp2);
          // result = strTmp1.localeCompare(strTmp2);
          break;
        case 26: //费用类型
          strTmp1 = obja.typename;
          strTmp2 = objb.typename;
          result = strTmp1.localeCompare(strTmp2);
          break;
        case 28: //构件BizObjT_Item为28 在ResConst
          strTmp1 = obja.itemcode;
          strTmp2 = objb.itemcode;
          result = strTmp1.localeCompare(strTmp2);
          break;
        case 29: //模型
          intTmp1 = obja.seq;
          //如果序号为 0 ，使用 TssCode 排序
          if (intTmp1 == 0) {
            strTmp1 = obja.itemcode;
            strTmp2 = objb.itemcode;
            result = strTmp1.localeCompare(strTmp2);
          }
          else {
            intTmp2 = objb.seq;
            result = intTmp1 - intTmp2;
          }
          break;
        case 30:
        case 31:
        case 32:
        case 33:
        case 34:
        case 35:
        case 36: //费用
          result = 0;
          break;
        case 39: //资源
          strTmp1 = obja.resname;
          strTmp2 = objb.resname;
          result = strTmp1.localeCompare(strTmp2);
          break;
        case 42: //营销活动
          strTmp1 = obja.subject;
          strTmp2 = objb.subject;
          result = strTmp1.localeCompare(strTmp2);
          break;
        case 82: //知识
          strTmp1 = obja.subject;
          strTmp2 = objb.subject;
          result = strTmp1.localeCompare(strTmp2);
          break;
        case 97: //项目分类
          strTmp1 = obja.projcname;
          strTmp2 = objb.projcname;
          result = strTmp1.localeCompare(strTmp2);
          break;
        case 98: //项目
          strTmp1 = obja.projname;
          strTmp2 = objb.projname;
          result = strTmp1.localeCompare(strTmp2);
          break;
        default: //非Tss类型业务对象，按XxxName属性排序
          strTmp1 = '';
          strTmp1 = '';

          //其他...delphi端有classname来取..WEB...随缘
          //let strPropName = obja.classname;
          //strPropName = Copy(strPropName, 5, length(strPropName) - 4) + 'name';
          //if strTmp1 = '' then
          //strTmp1 = GetPropValue(BizObj1, strPropName);
          //if strTmp2 = '' then
          //strTmp2 = GetPropValue(BizObj2, strPropName);
          //result = strTmp1.localeCompare(strTmp2);

          if (strTmp1 == '') {
            strTmp1 = 'unknown';
          }
          if (strTmp2 == '') {
            strTmp2 = 'unknown';
          }
          result = strTmp1.localeCompare(strTmp2);
          break;
      }//end case
      return result;
    }

  }

  /**
   * @param res 后台返回的数据
   * @param dataSvc 传的是 Injectable  为了树结构的懒加载
   */
  getRes(res: any,dataSvc:any) {
    let data;
    if (res.fdrs){//文件夹
      res.fdrs.sort(this.ReOrderDataList);
      data = new wjcCore.CollectionView(dataSvc.getData(res));
    }
    if (res.dsss) {//业务文档
      res.dsss.sort(this.ReOrderDataList);
      data = new wjcCore.CollectionView(dataSvc.getData(res));
    }
    if (res.docs) { //文档排序
      res.docs.sort(this.ReOrderDataList);
      data = new wjcCore.CollectionView(dataSvc.getData(res));
    }
    if (res.shortcuts) { //快捷方式文件夹
      res.shortcuts.sort(this.ReOrderDataList);
      data = new wjcCore.CollectionView(dataSvc.getData(res));
    }
    return data;
  }


  /**  判断有没有数据
   * @param res  后台response的数据
   * return true or false
   */
  noData(res: any){
    if (res.fdrs) { //非业务文档
      if (res.fdrs.length == 0 && res.dsss == 0 && res.docs.length == 0 && res.shortcuts.length == 0) {
        return true;
      } else {
        return false;
      }
    } else {//业务文档 (业务文档是没有文件夹的)
      if (res.dsss == 0 && res.docs.length == 0 && res.shortcuts.length == 0) {
        return  true;
      } else {
        return  false;
      }
    }
  }

  //后台返回的数据 根据名字排序一下
  SortLikeWin(obja, objb) {

    //不同浏览器的 对于 localeCompare方法的  中英比较返回的值都不太一样 所以要确定把英文放在中文之前
    // 所以英文和中文  比较要英文在前
    function compare(a, b) {
      return ('f'.localeCompare('黄', 'zh') == -1) ? a.localeCompare(b, 'zh') : b.localeCompare(a, 'zh');
    }
    //orgname 机构名 username 用户名 receivername 文档管理权限的 用户或者机构名
    //catname 菜单分类名称 addressname 地址簿
    let compField = obja['_compareField'];//需要按照什么字段来排序
    let a =compField ? obja[compField] : (obja.confdesc || obja.orgname || obja.username || obja.receivername  || obja.menuname || obja.catname || obja.addressname|| obja.codename ||'');
    let b = compField ? objb[compField] : (objb.confdesc || objb.orgname || objb.username || objb.receivername  || objb.menuname || objb.catname || objb.addressname|| objb.codename || '');
    let reg = /^[0-9]+/;
    let lista = a.match(reg);
    let listb = b.match(reg);
    if (!lista || !listb) {
      //直接调用 localeCompare这个方法 中英文比较  会把中文排序到前面，
      // 但是 需求是 英文要先排序。所以要单独处理 中英文的比较
      let num = /[0-9]/;
      let en = /[a-z]/i;
      let zh = new RegExp("[\\u4E00-\\u9FFF]+");

      let starta = a.substring(0, 1);
      let startb = b.substring(0, 1);
      let aWhat = num.test(starta) ? 'num' : en.test(starta) ? 'en' : zh.test(starta) ? 'zh' : '';
      let bWhat = num.test(startb) ? 'num' : en.test(startb) ? 'en' : zh.test(startb) ? 'zh' : '';
      //('f'.Localeompare('黄')==-1)?xx.localeCompare(yy):yy.localeCompare(xx)
      if ((aWhat == 'zh' && bWhat == 'en') || (aWhat == 'en' && bWhat == 'zh')) {
        return compare(a, b);
      }
      return a.localeCompare(b);
    }


    for (let i = 0, minLen = Math.min(lista.length, listb.length); i < minLen; i++) {
      //数字所在位置序号
      let indexa = a.indexOf(lista[i]);
      let indexb = b.indexOf(listb[i]);
      //数字前面的前缀
      let prefixa = a.substring(0, indexa);
      let prefixb = a.substring(0, indexb);
      //数字的string
      let stra = lista[i];
      let strb = listb[i];
      //数字的值
      let numa = parseInt(stra);
      let numb = parseInt(strb);
      //如果数字的序号不等或前缀不等，属于前缀不同的情况，直接比较
      if (indexa != indexb || prefixa != prefixb) {
        return a.localeCompare(b);
      }
      else {
        //数字的string全等
        if (stra === strb) {
          //如果是最后一个数字，比较数字的后缀
          if (i == minLen - 1) {
            return a.substring(indexa).localeCompare(b.substring(indexb));
          }
          //如果不是最后一个数字，则循环跳转到下一个数字，并去掉前面相同的部分
          else {
            a = a.substring(indexa + stra.length);
            b = b.substring(indexa + stra.length);
          }
        }
        //如果数字的string不全等，但值相等
        else if (numa == numb) {
          //直接比较数字前缀0的个数，多的更小
          return strb.lastIndexOf(numb + '') - stra.lastIndexOf(numa + '');
        }
        else {
          //如果数字不等，直接比较数字大小
          return numa - numb;
        }
      }
    }
  }

  //判断是移动还是pc
  IsPC() {
    let userAgentInfo = navigator.userAgent;
    let Agents = ["Android", "iPhone",
      "SymbianOS", "Windows Phone",
      "iPad", "iPod"];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag;
  }

  // 葡萄城控件的多语言化
  selectedIndexChanged(s, e) {

    // get culture url
    // debugger
    let url = 'assets/wijmo/wijmo.culture.';

    // apply new culture to page
    let scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      let script = scripts[i];
      if (script.src.indexOf('/resources/wijmo.culture.') > -1) {
        script.parentElement.removeChild(script);
        script = document.createElement('script');
        // script.onload = updateTables;
        script.src = url;
        document.head.appendChild(script);
        break;
      }
    }

  }
  //所有的调用了webSQLtool的 都要进行 sql加密
  getEncodeSQL(sql) {
    return '*2AB' + this.base64encode(this.utf16to8(this.base64encode(this.utf16to8(sql)))) + '===='
  }

  /**
   * @description 计算当前日期是不是 前天昨天今天
   * @param date 格式 YYYY-MM-DD hh:mm:ss
   */
  getTimeShowText(date) {
    let result = '';
    if (!date) return result;
    //年月日
    let YandMandD = date.substring(0, date.indexOf(' '));
    //时分
    let hoursAndMinutes = date.substring(date.indexOf(' '), date.length - 3);
    //需要计算的时间
    /**
     * @description 注意避坑
     * new Date( '2023/05/12')
     * Fri May 12 2023 00:00:00 GMT+0800 (中国标准时间)
     * new Date( '2023-05-12')
     * Fri May 12 2023 08:00:00 GMT+0800 (中国标准时间)
     */
    let computeTime = Number(new Date(YandMandD).setHours(0));
    //当前时间
    let today = Number(new Date());

    if ((today - computeTime) / (3600 * 1000) <= 24) { //今天
      result = '今天' + ' ' + hoursAndMinutes;
    } else if (24 < ((today - computeTime)) / (3600 * 1000) && (today - computeTime) / (3600 * 1000) <= 48) {//昨天
      result = '昨天' + ' ' + hoursAndMinutes;
    } else if (48 < (today - computeTime) / (3600 * 1000) && (today - computeTime) / (3600 * 1000) <= 72) {//前天
      result = '前天' + ' ' + hoursAndMinutes;
    } else {
      result = YandMandD;
    }
    return result;
  }
}





// WEBPACK FOOTER //
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/src/app/cpc-web-api.service.ts